import Check from "@mui/icons-material/Check";
import { Box, Button, Typography } from "@mui/material";
import { useAuthContext } from "features/auth/AuthContext";
import EmptyMessage from "components/EmptyMessage";
import { Order } from "models/Order";
import { useReviewOrderMutation } from "app/api/orders";
import UserActivity from "components/UserActivity";

type ReviewSectionProps = { order: Order };

const ReviewSection: React.FC<ReviewSectionProps> = ({ order }) => {
  const { user } = useAuthContext();

  const [reviewOrder, { isLoading }] = useReviewOrderMutation();

  const renderContent = () => {
    if (!order.selectedForReview) return <EmptyMessage>Ej utvald för granskning</EmptyMessage>;

    if (order.reviewedBy && order.reviewedAt)
      return (
        <>
          <Typography fontWeight="bold">Granskad</Typography>
          <UserActivity time={order.reviewedAt} user={order.reviewedBy} />
        </>
      );

    if (user?.isOrderReviewer && user.office?.name === order.coordinator)
      return (
        <Button
          variant="text"
          startIcon={<Check />}
          onClick={() => reviewOrder({ orderNr: order.ordernr })}
          disabled={isLoading}
        >
          Markera granskad
        </Button>
      );

    return <EmptyMessage>Väntar granskning</EmptyMessage>;
  };

  return (
    <Box>
      <Box px={2} pb={1}>
        {renderContent()}
      </Box>
    </Box>
  );
};

export default ReviewSection;
